<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title class="d-flex justify-space-between">
          <v-btn
            class="ma-2"
            color="secondary"
            @click="$router.back()"
            outlined
            dark
          >
            <v-icon>mdi-arrow-left</v-icon>
            Back
          </v-btn>

          <v-btn color="primary" @click="edit()"> Save Changes </v-btn>
        </v-card-title>
        <v-card-title class="pl-6"
          >{{ customerDetail.description }}' Courses</v-card-title
        >
        <div class="pa-5 pl-6">
          <v-select
            v-model="courses"
            :items="getCourseLookup"
            @change="onCourseChange()"
            item-text="title"
            item-value="id"
            label="Select Courses"
            multiple
            outlined
            chips
            item-disabled
            props
          ></v-select>
        </div>
      </base-card>
    </v-col>
  </v-row>
</template>

<script>
import { difference, each, find, get, map, sortBy } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Form Student Course",
  },

  data() {
    return {
      loading: false,
      customer: null,
      courses: [],
      customerDetail: {},
    };
  },

  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.customer = Number(id);

      this.customerDetail = find(this.getCustomers, { id: this.customer });

      each(
        get(this.getCustomerCourses[this.customer], "courses", []),
        (courses) => {
          this.courses.push(courses.id);
          this.onCourseChange();
        }
      );
    }
  },

  methods: {
    ...mapActions([
      "addCustomerCourse",
      "deleteCustomerCourse",
      "showSnackbar",
    ]),

    async edit() {
      const originalCourses = [];
      each(
        get(this.getCustomerCourses[this.customer], "courses", []),
        (courses) => originalCourses.push(courses.id)
      );

      const removed = difference(originalCourses, this.courses);
      const added = difference(this.courses, originalCourses);
      try {
        // Removed students
        if (removed.length) {
          await this.deleteCourse(removed);
        }

        // Add students
        if (added.length) {
          await this.addCustomerCourse({
            courseLookupIds: added,
            customerId: this.customer,
          });
        }

        await this.showSnackbar("Student course updated successfully!");
        this.$router.push("/app/customer");
      } catch (error) {
        await this.showSnackbar("Something went wrong!");
      }
    },

    async deleteCourse(ids) {
      await this.deleteCustomerCourse({
        customerId: this.customer,
        courseLookupIds: ids,
      });
    },

    async add() {
      try {
        await this.addCustomerCourse({
          courseLookupIds: this.courses,
          customerId: this.customer,
        });

        await this.showSnackbar("Student course updated successfully!");
        this.$router.push("/app/customer");
      } catch (error) {
        await this.showSnackbar("Something went wrong!");
      }
    },

    onCourseChange() {
      const list = map(this.courses, (courseId) =>
        find(this.getCourseLookup, { id: courseId })
      );

      this.courses = map(sortBy(list, "title"), (course) => get(course, "id"));
    },
  },
  computed: {
    ...mapGetters(["getCustomerCourses", "getCustomers", "getCourseLookup"]),
  },
};
</script>
<style lang="scss" scoped></style>
